<template>
    <div v-bind:style="styles" class="d-flex align-items-center justify-content-center">
        <i class="fas fa-circle-notch fa-spin"></i>
    </div>
</template>

<script>
    export default {
        props: {
            height: {
                type: Number,
                default: 50,
            }
        },

        data: function () {
            return {
                //
            };
        },

        computed: {
            styles() {
                return {
                    height: `${this.height}px`
                };
            },
        },

        methods: {
            //
        },
    }
</script>

<style scoped>

</style>
